import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';

import { getBancos } from '../../../api';

import { BaseLabel, RowContainer, AutoCompleteSmall, Select } from '../../../../styles/styleUtils';

function BancoEmissor({ formData, onAutoCompleteChange, onInputChange }) {
  const [bancos, setBancos] = useState([]);
  const fetchData = async () => {
    const result = await getBancos();
    setBancos(result);
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div>
      <RowContainer>
        <BaseLabel htmlFor="bancoEmissor">Banco Emissor</BaseLabel>
        <AutoCompleteSmall
          disablePortal
          id="bancoEmissor"
          name="bancoEmissor"
          value={formData.bancoEmissor || null}
          onChange={(_, value) => onAutoCompleteChange('idBancoEmissor','bancoEmissor', value)}
          options={bancos}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} placeholder="Selecione" />}
        />
      </RowContainer>
      <RowContainer>
        <BaseLabel htmlFor="antecipacaoAutomatica">Antecipação Automática</BaseLabel>
        <Select
          id="antecipacaoAutomatica"
          name="antecipacaoAutomatica"
          value={formData.antecipacaoAutomatica}
          onChange={onInputChange}
        >
          <option value="">Selecione</option>
          <option value={'sim'}>Sim</option>
          <option value={'nao'}>Não</option>
        </Select>
      </RowContainer>
    </div>
  );
}

export default BancoEmissor;
